// extracted by mini-css-extract-plugin
export default {"dialog_report":"uP4r8"};